<template>
    <div id="business-address-iff-container">
      <Choices
        :inputField="inputs.products"
        inputName="What are you interested in?"
        inputType=""
        :options="[
            'Working Capital',
            'Credit Line', 
            'Invoice Factoring',
            'Equipment Financing',
            'Vehicle Financing'
          ]"
      />
      <List
        :inputField="inputs.funds_needed_timeframe"
        :options="funds_timeframe_needed_options"
        inputName="When do you need funds?"
        inputId="funds_needed_timeframe"
        :fullWidthOption="false"
      />
      <List
        :inputField="inputs.securing_financing"
        inputName="What is most important when securing financing?"
        :options="[
          'Speed',
          'Amount',
          'Cost',
        ]"
        inputId="securing_financing"
        :fullWidthOption="false"
      />
      <Dropdown
        @enter="next"
        :inputField="inputs.refer"
        inputName="How did you hear about us?"
        inputType="string"
        :options="referOptions"
        />
      <Input
        v-show="other_selected == true"
        :inputField="inputs.other_referrer"
        inputName="Other"
        inputType="string"
        @enter="next"
      />
      <br/>
      <br/>
      <div class="buttons is-right">
      <!-- <a v-if="!validate" class="button is-link is-inverted padded-button next-button" @click="back">Back</a> -->
        <a class="button is-link padded-button next-button continue-button" @click="next">Continue</a>
      </div>
    </div>
    
  </template>
  
  <script>
  import Vue from "vue";
  import Input from "@/components/shared/Input";
  import ApplyPage from "@/components/shared/ApplyPage";
  import List from "@/components/shared/List";
  import Choices from "@/components/shared/Choices";
  import Dropdown from "@/components/shared/Dropdown";
  import $ from "jquery";
  
  export default {
    name: "BusinessAddressIFF",
    components: {
      Input,
      Dropdown,
      Choices,
      List
    },
    mixins: [ApplyPage],
    props: {
    },
    created: function () {

    },
    data() {
      return {
        obj: "business",
        funds_timeframe_needed_options: [
          "Immediately",
          "With in a week",
          "With in a month"
        ],
        referOptions: [
            "Bing",
            "Cardiff Representative",
            "Elevator Funding",
            "Facebook",
            "Google",
            "Instagram",
            "Podcast",
            "Spotify",
            "TikTok",
            "Youtube",
            "Other",
        ],
        other_selected: false,
        inputs: {
          products: Input.model(),
          funds_needed_timeframe: Input.model(),
          securing_financing: Input.model(),
          refer: Input.model(),
          other_referrer: Input.model(),  
        },
      };
    },
    methods: {
      handleBlur: function () {
        console.log("focus out");
      },
    },
    mounted: function () {
      $('#Immediately').trigger('click');
      $('#Speed').trigger('click');
      let svg = `<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="6.5" cy="6.5" r="6" fill="white" stroke="#999999"/>
<path d="M7.21436 4.18848V10H5.79102V4.18848H7.21436ZM5.69434 2.66846C5.69434 2.45719 5.76595 2.28174 5.90918 2.14209C6.05599 2.00244 6.25293 1.93262 6.5 1.93262C6.74707 1.93262 6.94222 2.00244 7.08545 2.14209C7.23226 2.28174 7.30566 2.45719 7.30566 2.66846C7.30566 2.87614 7.23226 3.0498 7.08545 3.18945C6.94222 3.3291 6.74707 3.39893 6.5 3.39893C6.25293 3.39893 6.05599 3.3291 5.90918 3.18945C5.76595 3.0498 5.69434 2.87614 5.69434 2.66846Z" fill="#999999"/>
</svg>
`;
      // $('#Working_Capital').parent().before("<div class='product_info_container'>" + svg + "<label class='product_info_label'>1+ years in business</label></div>");
      $('#Equipment_Financing').parent().before("<br/><div class='product_info_container'>" + svg + "<label class='product_info_label'>2+ years time in business</label><div>");
    },
    watch: {
      inputs: {
        deep: true,
        handler(newValue, oldvalue) {
            if (newValue.refer.value == "Other") {
                this.other_selected = true;
            // this.inputs.other_referrer.value = "";
            } else {
                this.other_selected = false;
                this.inputs.other_referrer.value = "  ";
            }
        },
      },
    },
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#business-address-iff-container .list-full-option{
  width: 100%;
  margin-bottom: 0!important;
}
.product_info_container{
  /* float: left; */
  /* margin-left: 20px; */
  margin-bottom: 8px;
  width: 100%;
  text-align: center;
  clear: both;
}
.product_info_label{
  color: #666;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
  vertical-align: text-top;
  margin-left: 4px;
}
</style>